module.exports = __webpack_public_path__ + "static/img/bingxue.eca27502.png";